module.exports = __webpack_public_path__ + "static/media/configuration.a89738b8.svg";